import { Injectable, signal } from '@angular/core';
import { AuthorizedEntityDTO } from '../models/authorized-entity.model';

@Injectable({ providedIn: 'root' })
export class AuthorizedEntityDetailsService {
    private _authorizedEntity = signal<AuthorizedEntityDTO | null>(null);

    authorizedEntity = this._authorizedEntity.asReadonly();

    open(authorizedEntity: AuthorizedEntityDTO) {
        this._authorizedEntity.set(authorizedEntity);
    }

    close() {
        this._authorizedEntity.set(null);
    }

    toggle(authorizedEntity: AuthorizedEntityDTO) {
        const current = this._authorizedEntity();
        this._authorizedEntity.set(current?.uuid === authorizedEntity.uuid ? null : authorizedEntity);
    }
}
